import { Component, OnInit } from '@angular/core'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { MemberIPadService } from '../../gateways/enrollment-data-service'
import { Router } from '@angular/router'
import { ExcelService } from '../../excel.service'

@Component({
    selector: 'ipadloginhistory',
    template: `<h3>{{ displayText }}</h3>`
})
export class ClsIPadLoginHistory implements OnInit {
    displayText = ''

    downloadAgain: boolean = false
    constructor(
        private excelService: ExcelService,
        private gateway: EnrollmentGateway,
        public router: Router,
        private membermailservice: MemberIPadService
    ) {}

    ngOnInit() {
        this.displayText = 'Your Report is being downloaded...'
        this.downloadAgain = false
        this.exportToExcel()
    }

    exportToExcel() {
        this.gateway.downloadIPadLoginHistoryExcel().subscribe((model: any) => {
            let currentdate = new Date()
            let monthNum = currentdate.getMonth() + 1
            let month = monthNum < 10 ? '0' + monthNum : monthNum
            let date = currentdate.getDate() < 10 ? '0' + currentdate.getDate() : currentdate.getDate()
            let fileName = 'iPadFirstLoginDetails' + '_' + currentdate.getFullYear() + '_' + month + '_' + date
            this.excelService.exportAsExcelFileIpad(model, fileName)
            this.downloadAgain = true
            this.displayText = 'The report ' + fileName + '.xlsx has been successfully downloaded.'
        })
    }
}
